import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import About from "@/components/About";
import Products from "@/components/Products";
import Services from "@/components/Services";
import Stats from "@/components/Stats";
import WhyChooseUs from "@/components/WhyChooseUs";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Home() {
  return (
    <div className="relative" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <About />
        <Products />
        <Services />
        <Stats />
        <WhyChooseUs />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
